import { SvgIconProps } from './icon-props';

export default function Search({ height = 35, width = 34, fill = 'black' }: SvgIconProps) {
	return (
		<svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 35">
			<path
				d="M21.6 22.2c2.6-2.3 4.2-5.6 4.2-9.3C25.8 6 20.1.5 13.1.5 6.2.5.5 6 .5 12.9c0 6.8 5.7 12.4 12.7 12.4 2.9 0 5.5-.9 7.6-2.5l12.4 12.1.7-.7-12.3-12zm-8.4 2.1c-6.4 0-11.7-5.1-11.7-11.4 0-6.3 5.2-11.4 11.7-11.4 6.4 0 11.7 5.1 11.7 11.4-.1 6.3-5.3 11.4-11.7 11.4z"
				fill={fill}
			/>
		</svg>
	);
}
